import Vue from 'vue'

// One save record per (company, setting), held at module scope so it outlives the component.
//
// Collapsing a settings section destroys the instance (settings-section.component.vue's v-if), and
// a save in flight has to keep its place in the queue and keep its requested value across that, or
// a reopened section starts a second request that can land out of order and seeds its field from a
// store that has not caught up yet. Reactive, so a reopened instance follows the outcome of a save
// its predecessor started. The chain is stored alongside but nothing renders from it.
//
// Keyed by company as well as setting because the id the portal serves is the Setting row's, which
// is the same for every company -- only `overridden` differs. This map outlives a company switch,
// since the header navigates to company-select without a reload, so keyed by setting alone a save
// still in flight for one company would seed the next company's field with its value, and a blur
// there would post it.
//
// In its own module rather than inside the component so the records can be asserted on: removing
// one is the delicate part, and it is not observable from outside any other way.
export const savesByCompanySetting = Vue.observable({})

export function saveKeyFor (companyId, settingId) {
  return `${companyId}:${settingId}`
}

export function saveStateFor (key) {
  if (!savesByCompanySetting[key]) {
    Vue.set(savesByCompanySetting, key, {
      seq: 0,
      requested: null,
      chain: Promise.resolve(),
      // the last value the server refused, and a counter so the same value failing twice still
      // registers as a second refusal rather than an unchanged watcher dependency
      refusedValue: null,
      refusals: 0
    })
  }
  return savesByCompanySetting[key]
}

export function forgetSaveState (key) {
  Vue.delete(savesByCompanySetting, key)
}
